<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card color="green" flat full-width title="Категории каталога">
          <v-spacer />
          <v-dialog v-model="dialog">
            <template #activator="{ on, attrs }">
              <v-btn color="blue" dark class="mb-2" v-bind="attrs" v-on="on">
                Новая запись
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span
                  v-if="newItem"
                  class="headline"
                >Добавление Категории в {{ editedItem.parent_id }}</span>
                <span
                  v-if="!newItem"
                  class="headline"
                >Редактирование Категории</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-text-field v-model="editedItem.parent_id" type="number" label="id родителя" />
                  <v-text-field
                    v-model="editedItem.position"
                    type="number"
                    label="Очередность в списке (позиция)"
                  />
                  <v-text-field
                    v-model="editedItem.name"
                    label="Название"
                    @change="trans"
                  />
                  <v-text-field v-model="editedItem.slug" label="Slug" />
                  <v-select
                    v-model="editedItem.type"
                    :items="[ 'category', 'collection', 'srez']"
                    label="Type"
                  />
                  <v-select
                    v-model="editedItem.status"
                    :items="['active','disable']"
                    label="Status"
                  />
                  <select-c
                    :open-dialog="dialog"
                    :default="editedItem.params"
                    @selected="UpdateParams"
                  />
                  <v-checkbox v-model="editedItem.displaySeoText" label="Отображать Seo-текст"/>
                  <v-row>
                    <v-col>
                      <file-input :value="editedItem.images" bucket="image" @change="setImage" />
                    </v-col>
                  </v-row>
                  <v-data-table
                    :headers="headersExtras"
                    :items="editedItem.extras"
                    class="elevation-1"
                    hide-default-footer
                    items-per-page="-1"
                  >
                    <template #top>
                      Дополнительные параметры
                      <v-btn color="blue" @click="addExtras">
                        Add
                      </v-btn>
                    </template>
                    <template #item.name="{ item }">
                      <v-text-field v-model="item.name" label="Name" />
                    </template>
                    <template #item.value="{ item }">
                      <v-text-field v-model="item.value" label="Value" />
                    </template>
                    <template #item.action="{ item }">
                      <v-icon small @click="deleteExtra(item)">
                        mdi-bucket
                      </v-icon>
                    </template>
                  </v-data-table>
                  <v-alert
                    v-if="isError"
                    border="bottom"
                    color="red"
                    dismissible
                    text
                    dense
                    type="error"
                  >
                    {{ Error }}
                  </v-alert>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-data-table
            :headers="headers"
            :items="category"
            :options.sync="options"
            :server-items-length="totalDesserts"
            :loading="loading"
            class="elevation-1"
          >
            <template #top>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="searchid"
                    label="Поиск по ID"
                    class="mx-4"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="search"
                    label="Поиск по названию"
                    class="mx-4"
                  />
                </v-col>
                <v-col>
                  <v-select
                    v-model="searchtype"
                    :items="[ '', 'category', 'collection', 'srez']"
                    label="Поиск по типу"
                    class="mx-4"
                  />
                </v-col>
                <v-col>
                  <v-select
                    v-model="searchstatus"
                    :items="['', 'active', 'disable']"
                    label="Статус"
                  />
                </v-col>
              </v-row>
            </template>
            <!-- TODO: fix this v-slot def -->
            <!-- eslint-disable-next-line vue/valid-v-slot -- temp code style fix -->
            <template #item.actions="{ item }">
              <v-icon small class="mr-2" @click="editCategory(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteCategory(item)">
                mdi-bucket
              </v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  getCategory,
  CreateOfferCategory,
  deleteOfferCategory,
  updateOfferCategory
} from '@/graphql/category'
import { slugify } from 'transliteration'
import SelectC from '@/components/category/select'
import FileInput from '~/components/category/FileInput'

export default {
  components: {
    SelectC,
    FileInput
  },
  layout: 'dashboard',
  apollo: {
    Category: {
      query: getCategory,
      variables () {
        const search = []
        if (this.search.length > 0) {
          search.push({ name: 'name', value: this.search })
        }
        if (this.searchid.length > 0) {
          search.push({ name: 'id', value: this.searchid })
        }
        if (this.searchtype.length > 0) {
          search.push({ name: 'type', value: this.searchtype })
        }
        if (this.searchstatus.length > 0) {
          search.push({ name: 'status', value: this.searchstatus })
        }
        return {
          search,
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      result ({ data }) {
        if (data?.getCategory?.categores) {
          this.category = data?.getCategory?.categores
          this.totalDesserts = data?.getCategory?.count
        } else {
          this.totalDesserts = 0
        }
      },
      update: data => data?.getCategory?.categores
    }
  },
  data () {
    return {
      isError: false,
      Error: '',
      loading: false,
      search: '',
      searchid: '',
      searchtype: '',
      searchstatus: '',
      category: [],
      newItem: true,
      editedItem: {
        parent_id: 0,
        displaySeoText: false,
        extras: [{}]
      },
      dialog: false,
      active: [],
      paramsList: [],
      options: {},
      totalDesserts: 0,
      headersExtras: [
        {
          sortable: false,
          text: 'Name',
          value: 'name'
        },
        {
          sortable: false,
          text: 'Value',
          value: 'value'
        },
        {
          sortable: false,
          text: '#',
          value: 'action'
        }
      ],
      headers: [
        {
          sortable: false,
          text: 'ID',
          value: 'id'
        },
        {
          sortable: false,
          text: 'Поз',
          value: 'position'
        },
        {
          sortable: false,
          text: 'Name',
          value: 'name'
        },
        {
          sortable: false,
          text: 'Type',
          value: 'type'
        },
        {
          sortable: false,
          text: 'Status',
          value: 'status'
        },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  watch: {
    dialog (val) {
      if (val && this.newItem) {
        this.editedItem = Object.assign({
          parent_id: 0,
          extras: [{}]
        })
      }
    }
  },
  methods: {
    deleteExtra (item) {
      const index = this.editedItem.extras.indexOf(item)
      if (index > -1) {
        this.editedItem.extras.splice(index, 1)
      }
    },
    setImage (images) {
      this.editedItem.images = images
    },
    UpdateParams (val) {
      this.editedItem.params = val
    },
    editCategory (item) {
      this.newItem = false
      delete item.__typename
      delete item.children
      item.extras = item.extras.map((i) => { return { name: i.name, value: i.value } })
      this.editedItem = Object.assign({}, item)
      const index = this.editedItem?.extras?.findIndex(row => row.name === 'displaySeoText')
      if (index !== -1) {
        this.editedItem.displaySeoText = this.editedItem?.extras[index]?.value === 'true'
        this.editedItem?.extras?.splice(index, 1)
      }
      this.dialog = true
    },
    deleteCategory (item) {
      if (confirm('Уверены что хотите удалить категорию ' + item.name)) {
        this.$apollo
            .mutate({
              mutation: deleteOfferCategory,
              variables: {
                id: item.id
              }
            })
            .then((data) => {
              this.$apollo.queries.Category.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
      }
    },
    trans () {
      if (this.editedItem.slug === undefined || this.editedItem.slug.length < 1) {
        this.editedItem.slug = slugify(this.editedItem.name).replaceAll('-', '_')
      }
    },
    close () {
      this.dialog = false
      this.newItem = true
    },
    save () {
      const input = Object.assign({}, this.editedItem)
      input.parent_id = Number(input.parent_id)
      input.position = Number(input.position)
      if (input?.images) {
        input?.images.forEach((item) => {
          item.key = item?.file?.key
          delete item.file
          delete item.__typename
        })
      }
      if (input?.displaySeoText !== undefined) {
        const index = input?.extras?.findIndex(row => row.name === 'displaySeoText')
        if (index !== -1) {
          input.extras[index].value = input?.displaySeoText.toString()
        } else {
          input.extras.push({ name: 'displaySeoText', value: input.displaySeoText.toString() })
        }
        delete input.displaySeoText
      }
      delete input.id
      if (this.newItem) {
        this.$apollo
            .mutate({
              mutation: CreateOfferCategory,
              variables: { input }
            })
            .then((data) => {
              this.$apollo.queries.Category.refetch()
              this.close()
            })
            .catch((error) => {
              this.Error = error
              this.isError = true
              console.error(error)
            })
      } else {
        const id = this.editedItem.id
        this.$apollo
            .mutate({
              mutation: updateOfferCategory,
              variables: { id, input }
            })
            .then((data) => {
              this.$apollo.queries.Category.refetch()
              this.close()
            })
            .catch((error) => {
              this.Error = error
              this.isError = true
              console.error(error)
            })
      }
    },
    addExtras () {
      this.editedItem.extras.push({ name: '', value: '' })
    }
  }
}
</script>
